<template>
    <b-list-group flush>
        <b-list-group-item v-if="activeSelection">
            <div>
                <p>Current selection: {{currentSelection}} items.</p>
                <b-btn @click="invertSelection" class="">
                    <font-awesome-icon class="mr-1" icon="exchange-alt"></font-awesome-icon>
                    Invert selection
                </b-btn>
            </div>
        </b-list-group-item>
        <b-list-group-item>
            <b-form inline>
                <b-btn :disabled="!activeSelection" @click="exportItems">
                    <font-awesome-icon class="mr-1" icon="save"/>
                    Export
                </b-btn>
                <span id="info-export" class="icon-button ml-1 mr-1">
                    <font-awesome-icon icon="info-circle"/>
                </span>
                <b-tooltip target="info-export">Extract a plain-text file containing the subset of
                    the rows that are currently selected, a CSV file.
                </b-tooltip>
            </b-form>
            <b-form-text v-if="!activeSelection"> No selection to export.</b-form-text>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
    import {mapGetters} from 'vuex';
    import downloadAsFile from 'download-as-file';
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import Papa from 'papaparse'

    export default {
        name: "SelectionSummary",
        components: {
            FontAwesomeIcon
        },
        data() {
            return {
                savedSelection: null
            };
        },
        methods: {
            invertSelection() {
                this.$store.commit('invertSelection');
            },
            exportItems() {
                downloadAsFile({
                    data: Papa.unparse(this.getSelection),
                    filename: 'selection_' + Date.now().toString() + '.csv'
                })
                ;
            },
            formatFloat(v) {
                return v.toLocaleString(undefined, {maximumFractionDigits: 2});
            }
        },
        computed: {
            currentSelection() {
                if (this.activeSelection) {
                    let selectionLength = this.getSelection.length
                    return String(selectionLength) + ' (' + String(this.formatFloat(selectionLength / this.nbIndividuals * 100)) + '%)';
                }
                return '';
            },
            // mix the getters into computed with object spread operator
            ...mapGetters(['activeSelection', 'getSelection', 'nbIndividuals'])
        }
    };
</script>

<style>
</style>
